import { render, staticRenderFns } from "./CampaignDetailsPopup.vue?vue&type=template&id=24f01742&scoped=true"
import script from "./CampaignDetailsPopup.vue?vue&type=script&lang=js"
export * from "./CampaignDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=24f01742&prod&scoped=true&lang=css&external"
import style1 from "./CampaignDetailsPopup.vue?vue&type=style&index=1&id=24f01742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f01742",
  null
  
)

export default component.exports